export const quantizeStep = (step) => {
    return Math.round(step * 2) / 2;
};

export const quantizeValue = (parameter, value) => {
    if (value === undefined) {
        return value;
    }

    if (parameter.quantize) {
        return parameter.quantize(value);
    }
    let {min, max} = parameter;
    let diff = max - min;
    let x = diff / 80;
    let {defaultValue} = parameter.config;
    if (Math.abs(defaultValue - value) < x / 8) {
        return defaultValue;
    }
    if (max < 20) {
        return Math.round(value * 10) / 10;
    }
    let remainder = value % x;
    if (remainder > x / 2) {
        return value + x - remainder;
    }
    return value - remainder;
};

